// extracted by css-extract-rspack-plugin
var _1 = "THjzJ7F12D8atIPD";
var _2 = "mJ1EacfLbQWfHw_t";
var _3 = "bQfSz73pwEMLnvGA";
var _4 = "Y2673YPj44XqAOx7";
var _5 = "MbvYafK_t0Y4gDCl";
var _6 = "fePdwI6fPI8_bSTY";
var _7 = "UJb7rpgQYktzh9v1";
var _8 = "hW1ucSrgwA5EOq7Q";
var _9 = "NzJm1BdrQdIODkkg";
var _a = "KTVAeuM2skku19ce";
var _b = "Edj5uVqP_ls367MU";
var _c = "xUAVzNI4Nrg1TEHS";
var _d = "o74kez2nZW47DPFi";
var _e = "XiwW1ZAq8w_CuoYS";
var _f = "XRO9THjOI4zh4hcr";
var _10 = "cvfnsbeKspkwQ5Wp";
var _11 = "zTp1d9KFy0cM2_oj";
var _12 = "TeFZvXUVy0EKMmKv";
var _13 = "T2tENF0JaYWAWWbN";
var _14 = "vbURQGO4r78iTncs";
var _15 = "gpumK2JMWuMCwC__";
var _16 = "FnPEqpL_Q2Idn90X";
var _17 = "lQUD5tuNYs1OMDFh";
var _18 = "SIJBRuRn50LWPWfc";
var _19 = "Zh8HYPXU9Q1sQNj8";
var _1a = "mk8_TeyCPtsr6ihP";
var _1b = "THjzJ7F12D8atIPD";
var _1c = "mJ1EacfLbQWfHw_t";
var _1d = "bQfSz73pwEMLnvGA";
var _1e = "NzJm1BdrQdIODkkg";
var _1f = "KTVAeuM2skku19ce";
var _20 = "Edj5uVqP_ls367MU";
var _21 = "xUAVzNI4Nrg1TEHS";
var _22 = "Y2673YPj44XqAOx7";
var _23 = "MbvYafK_t0Y4gDCl";
var _24 = "fePdwI6fPI8_bSTY";
var _25 = "UJb7rpgQYktzh9v1";
var _26 = "hW1ucSrgwA5EOq7Q";
var _27 = "o74kez2nZW47DPFi";
var _28 = "XiwW1ZAq8w_CuoYS";
var _29 = "XRO9THjOI4zh4hcr";
var _2a = "cvfnsbeKspkwQ5Wp";
var _2b = "zTp1d9KFy0cM2_oj";
var _2c = "TeFZvXUVy0EKMmKv";
var _2d = "T2tENF0JaYWAWWbN";
var _2e = "FnPEqpL_Q2Idn90X";
var _2f = "vbURQGO4r78iTncs";
var _30 = "gpumK2JMWuMCwC__";
var _31 = "lQUD5tuNYs1OMDFh";
var _32 = "SIJBRuRn50LWPWfc";
var _33 = "Zh8HYPXU9Q1sQNj8";
var _34 = "mk8_TeyCPtsr6ihP";
export { _1 as "ts-attempts", _2 as "ts-card--medium", _3 as "ts-card--squared", _4 as "ts-player-stats", _5 as "ts-player-stats-container", _6 as "ts-player-stats-header", _7 as "ts-player-stats-player", _8 as "ts-player-stats-wrap", _9 as "ts-player__first-name", _a as "ts-player__flag", _b as "ts-player__info", _c as "ts-player__name", _d as "ts-player__team", _e as "ts-rank", _f as "ts-rank__label", _10 as "ts-scored", _11 as "ts-scored-data", _12 as "ts-scored__datas", _13 as "ts-stats", _14 as "ts-stats-card", _15 as "ts-stats-card-wrap", _16 as "ts-stats__assists", _17 as "ts-stats__container", _18 as "ts-stats__goals", _19 as "ts-stats__label", _1a as "ts-stats__minutes", _1b as "tsAttempts", _1c as "tsCardMedium", _1d as "tsCardSquared", _1e as "tsPlayerFirstName", _1f as "tsPlayerFlag", _20 as "tsPlayerInfo", _21 as "tsPlayerName", _22 as "tsPlayerStats", _23 as "tsPlayerStatsContainer", _24 as "tsPlayerStatsHeader", _25 as "tsPlayerStatsPlayer", _26 as "tsPlayerStatsWrap", _27 as "tsPlayerTeam", _28 as "tsRank", _29 as "tsRankLabel", _2a as "tsScored", _2b as "tsScoredData", _2c as "tsScoredDatas", _2d as "tsStats", _2e as "tsStatsAssists", _2f as "tsStatsCard", _30 as "tsStatsCardWrap", _31 as "tsStatsContainer", _32 as "tsStatsGoals", _33 as "tsStatsLabel", _34 as "tsStatsMinutes" }
